module.exports = __webpack_public_path__ + "static/img/1_2_2_1.2f1a91f2.jpg";